import React, { useEffect, useContext, useState } from 'react';
import { NavContext, NavRoutes, UserContext, ToastContext } from '../../../contexts';
import { BudgetProvider, BudgetContext } from './BudgetContext';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import CalendarTodayOutlined from '@material-ui/icons/CalendarTodayOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
	Paper,
	Avatar,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Typography,
	Hidden,
	Button,
	LinearProgress
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
	newYearContainer: {
		display: 'flex'
	},
	newYearDescription: {
		alignSelf: 'center',
		marginRight: '20px',
		fontSize: '1rem'
	},
	newYearBody: {
		width: "60px",
		margin: "0px 40px 0px 0px"
	},
	newYearButton: {
		fontSize: '12px'
	},
	root: {
		width: '100%',
		overflow: 'hidden',
		marginTop: '50px'
	},
	author: {
		display: 'flex',
		alignItems: 'center'
	},
	avatar: {
		marginRight: theme.spacing(1)
	},
	budgetSessionContainer: {
		display: 'flex',
		justifyContent: 'center'
	},
	budgetSessionName: {
		alignSelf: 'center',
		marginLeft: '15px',
		marginRight: '15px',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'space-evenly'
	},
	table: {

	}
}));

const PageContent = (props) => {
	const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);
	const { showSuccessMessage, showErrorMessage } = useContext(ToastContext);
	const classes = useStyles();

	const {
		activateBudgetYearAsync,
		getBudgetYearsAsync,
		budgetYears
	} = useContext(UserContext);

	const {
		state,
		getBudgetSessionsAsync,
		addNewBudgetYearAsync,
		getProjectsAmountAsync,
		advanceBudgetYearAsync,
		copyProjectsAsync,
		deleteBudgetYearAsync
	} = useContext(BudgetContext);

	const {
		isLoadingBudgetSessions,
		budgetSessions,
		addedYear
	} = state;

	useEffect(() => {
		addBreadcrumbToken("Years and budget sessions");
		getBudgetYearsAsync();
		getBudgetSessionsAsync();
	}, []);

	const [firstBudgetSession, setFirstBudgetSession] = useState(null);
	const [lastBudgetSession, setLastBudgetSession] = useState(null);
	
	useEffect(() => {
		if (budgetSessions !== null) {
			const lastItem = budgetSessions && budgetSessions.items && budgetSessions.items.pop();
			setLastBudgetSession(lastItem && lastItem.name);

			const firstItem = budgetSessions && budgetSessions.items && budgetSessions.items[0];
			setFirstBudgetSession(firstItem && firstItem.name);

		}
	}, [budgetSessions]);

	const [newYear, setNewYear] = useState("");
	const [creatingYear, setCreatingYear] = useState(false);
	const [activatingYear, setActivatingYear] = useState(null);
	const [advancingSession, setAdvancingSession] = useState(null);
	const [rollbackingSession, setRollbackingSession] = useState(null);
	const [copyingProjects, setCopyingProjects] = useState(null);
	const [deletingProjects, setDeletingProjects] = useState(null);

	const rollback = async budget => {
		setRollbackingSession(budget.budgetYearId);
		
		const isRollbacked = await advanceBudgetYearAsync({
			budgetYearId: budget.budgetYearId,
			rollback: true,
			pageIndex: 0,
			isLastIteration: true
		});

		setRollbackingSession(null);

		if (isRollbacked){
			getBudgetYearsAsync();
			showSuccessMessage("Budget session rollbacked!");
		}
		else
			showErrorMessage("An error has occurred");
	}

	const advance = async budget => {
		setAdvancingSession(budget.budgetYearId);

		//dividing projects and calling more times AdvanceBudgetYearAsync. This is a workaraound to avoid timeout issue (error 504) since Bulgari WAF doesn't accept more than 30 seconds long requests. This issue should be treated by passing the whole items array and the back end should immediately return 202 status. Then, every x seconds, a XMLHTTPRequest should be used to poll the background request.
		const totalProjects = await getProjectsAmountAsync({ year: budget.observedYear });

		if (totalProjects > 0){
			const pagesIndex =  totalProjects/50;
			let isBatchCompleted = false;
		
			for (let index = 0; index < pagesIndex; index++){
				isBatchCompleted = await advanceBudgetYearAsync({
					budgetYearId: budget.budgetYearId,
					rollback: false,
					pageIndex: index,
					isLastIteration: index >= pagesIndex - 1
				});

				if (!isBatchCompleted)
					break;
			}

			setAdvancingSession(null);

			if (isBatchCompleted){
				getBudgetYearsAsync();
				showSuccessMessage("Budget session advanced!");
			}
			else 
				showErrorMessage("An error has occurred");
		}
		else {
			const isAdvancedWithoutProjects = await advanceBudgetYearAsync({
				budgetYearId: budget.budgetYearId,
				rollback: false,
				pageIndex: 0,
				isLastIteration: true
			});

			setAdvancingSession(null);

			if (isAdvancedWithoutProjects){
				getBudgetYearsAsync();
				showSuccessMessage("Budget session advanced!");
			}
			else
				showErrorMessage("An error has occurred");
		}
	}

	const copyProjectsToNexyYear = async budget => {
		setCopyingProjects(budget.budgetYearId);

		//dividing projects and calling more times CloneProjectsToNextYearAsync. This is a workaraound to avoid timeout issue (error 504) since Bulgari WAF doesn't accept more than 30 seconds long requests. This issue should be treated by passing the whole items array and the back end should immediately return 202 status. Then, every x seconds, a XMLHTTPRequest should be used to poll the background request.
		const totalProjects = await getProjectsAmountAsync({ year: budget.observedYear });

		if (totalProjects > 0){
			const pagesIndex =  totalProjects/50;
			let allCopiedProjects = [];
		
			for (let index = 0; index < pagesIndex; index++){
				const chunckCopiedProjects = await copyProjectsAsync({
					sourceYear: budget.observedYear,
					pageIndex: index
				});


				if (chunckCopiedProjects?.length)
					allCopiedProjects = allCopiedProjects.concat(chunckCopiedProjects);
			}

			setCopyingProjects(null);

			if (allCopiedProjects.length)
				showSuccessMessage(`${allCopiedProjects.length} projects have been succesfully copied to the next year`);
			else
				showErrorMessage(`No new projects have been found missing in the next year`);
		}
		else
			showErrorMessage(`This year doesn't have any project!`);
	}

	return (
		<div>
			{isLoadingBudgetSessions ?
				<LinearProgress color="primary" /> :
				<>
					<div className={classes.newYearContainer}>
						<div className={classes.newYearDescription}>
							Add new year:
					</div>
						<TextField
							inputProps={{ min: 0, style: { textAlign: 'center' } }}
							value={newYear}
							onChange={event => {
								event.persist();
								setNewYear(event.target.value);
							}}
							margin="normal"
							className={classes.newYearBody}
						/>
						<div>
							{
								creatingYear ?
									<CircularProgress color="primary" /> :
									<Button
										variant="contained"
										color="primary"
										className={classes.newYearButton}
										onClick={() => {
											if (Number(newYear) && newYear.length == 4) {
												sendDataAsync();
												async function sendDataAsync() {
													setCreatingYear(true);
													await addNewBudgetYearAsync({ observedYear: Number(newYear) });
													getBudgetYearsAsync();
													setNewYear("");
													setCreatingYear(false);
												}
											}
											else
												showErrorMessage('The entered year must be composed of 4 numbers');
										}}
									>
										Submit
							</Button>
							}
						</div>
					</div>
					<Paper className={classes.root}>
						<Table className={classes.table} arial-label="role table">
							<TableHead>
								<TableRow>
									<TableCell align="left">Year</TableCell>
									<TableCell align="left">Active</TableCell>
									<TableCell align="center">Budget session and version</TableCell>
									<TableCell align="center"></TableCell>
									<TableCell align="right"></TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{
									budgetYears?.items?.map((budget, index) =>
										<TableRow hover key={index}>
											<TableCell component="th" scope="row">
												<div className={classes.author}>
													<Avatar aria-label="recipe" className={classes.avatar}>
														<CalendarTodayOutlined />
													</Avatar>
													<Typography>
														{budget.observedYear}
													</Typography>
												</div>
											</TableCell>
											<TableCell align="left">
												{
													activatingYear == budget.budgetYearId ?
														<CircularProgress color="primary" /> :
														<Switch
															color="primary"
															checked={budget.isActive}
															onChange={() => {
																sendDataAsync();

																async function sendDataAsync() {
																	setActivatingYear(budget.budgetYearId);
																	await activateBudgetYearAsync({ budgetYearId: budget.budgetYearId });
																	setActivatingYear(null);
																	getBudgetYearsAsync();
																}
															}}
														/>
												}
											</TableCell>
											<TableCell align="center">
												<div className={classes.budgetSessionContainer}>
													{
														budget.isActive &&
														(
															rollbackingSession === budget.budgetYearId ?
																<CircularProgress color="primary" /> :
																(
																	budget.currentBudgetSession &&
																	budget.currentBudgetSession.name !== firstBudgetSession &&
																	<Button
																		color="primary"
																		size="small"
																		variant="contained"
																		onClick={() => {
																			if (window.confirm("Are you sure you want to rollback this session?"))
																				rollback(budget);
																		}}
																	>
																		Previous session
														</Button>
																)
														)
													}
													<div className={classes.budgetSessionName}>
														{budget.currentBudgetSession &&
															budget.currentBudgetSession.name}
													</div>
													{
														budget.isActive &&
														(
															advancingSession === budget.budgetYearId ?
																<CircularProgress color="primary" /> :
																(
																	budget.currentBudgetSession &&
																	budget.currentBudgetSession.name !== lastBudgetSession &&
																	<Button
																		color="primary"
																		size="small"
																		variant="contained"
																		onClick={() => {
																			if (window.confirm("Are you sure you want to advance this session?"))
																				advance(budget);
																		}}
																	>
																		Next session
														</Button>
																)
														)
													}
												</div>
											</TableCell>
											<TableCell align="center">
												{
													budget.isActive &&
													(
														copyingProjects === budget.budgetYearId ?
															<CircularProgress color="primary" /> :
															<Button
																color="primary"
																size="small"
																variant="contained"
																onClick={() => {
																	if (window.confirm("Are you sure you want to copy all these year's projects to the next one?"))
																		copyProjectsToNexyYear(budget);
																}}
															>
																Copy projects to next year
											</Button>
													)
												}
											</TableCell>
											<TableCell align="right">
												<div className={classes.buttonContainer}>
													{
														deletingProjects === budget.budgetYearId ?
															<CircularProgress color="secondary" /> :
															<Button
																color="secondary"
																size="small"
																variant="contained"
																onClick={() => {
																	if (window.confirm("Are you sure you want to delete this budget session?"))
																		sendDataAsync();

																	async function sendDataAsync() {
																		setDeletingProjects(budget.budgetYearId);
																		await deleteBudgetYearAsync(budget.budgetYearId);
																		setDeletingProjects(null);
																		getBudgetYearsAsync();
																	}
																}}
															>
																Delete
												</Button>
													}
												</div>
											</TableCell>
										</TableRow>
									)}
							</TableBody>
						</Table>
					</Paper>
				</>
			}
		</div>
	);
}

export const BudgetPage = () => {
	return (
		<BudgetProvider>
			<PageContent />
		</BudgetProvider>
	);
}